<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">wifi用户分析</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <label class="datelabel">{{ date_start + '~' + date_end}}</label>
          <el-form-item label>
            <el-button @click="day">今日</el-button>
            <el-button @click="week">7天</el-button>
            <el-button @click="month">30天</el-button>
            <el-button @click="half">半年</el-button>
            <el-button @click="year">今年</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="echart">
          <div class="echart_1">
            <div>
              Wifi使用人次趋势
              <linechart
                :chartData="usePerData"
              ></linechart>
            </div>
            <div>
              Wifi使用时段
              <barchart
                :chartData="useTimeData"
              ></barchart>
            </div>
          </div>
          <div class="echart_2">
            <div>
              最热Wifi热点
              <barchart2
                :chartData="hotDotData"
              ></barchart2>
            </div>
            <div>
              手机品牌Top10
              <barchart
                :chartData="phoneTopData"
              ></barchart>
            </div>
          </div>
        </div>
      </zj-layout-main>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import linechart from "@/views/echart/LineEchart"
import barchart from "@/views/echart/BarEchart"
import barchart2 from "@/views/echart/BarEchart2"
export default {
  name: "WifiUserAnalysisView",
  controller: "UI",
  action: "WifiUserAnalysisView",
  components: {
    linechart,
    barchart,
    barchart2
  },
  data() {
    return {
      date_start: undefined,
      date_end: undefined,
      usePerData: {
        days: [],
        data: [],
      },
      useTimeData: {
        days: [],
        data: [],
      },
      hotDotData: {
        days: [],
        data: [],
      },
      phoneTopData: {
        days: [],
        data: [],
      },
    };
  },
  mounted: function () {
      this.getTime(0);
      this.getData(0);
  },
  methods: {
    getTime(value){
      var day = new Date();
      this.date_end = day.format("yyyy-MM-dd");
      if(value == 0){
        this.date_start = this.date_end;
      }
      if(value == 1){
        day.setTime(day.getTime() - (7 * 24 * 60 * 60 * 1000));
        this.date_start = day.format("yyyy-MM-dd");
      }
      if(value == 2){
        day.setTime(day.getTime() - (30 * 24 * 60 * 60 * 1000));
        this.date_start = day.format("yyyy-MM-dd");
      }
      if(value == 3){
        day.setTime(day.getTime() - (180 * 24 * 60 * 60 * 1000));
        this.date_start = day.format("yyyy-MM-dd");
      }
      if(value == 4){
        this.date_start = day.getFullYear() + '-' + '01' + '-' + '01';
      }
    },
    getData(type) {
      //Wifi使用人数、时段
      new MyApis.TranResourcesApi()
        .GetWifiVisitorUseReport({"BalanceUnit":type})
        .then((r) => {
          r = r.data.Data;
          this.usePerData ={
            days: r[0].categoryName,
            data: r[0].intValue,
          }
          this.useTimeData ={
            days: r[1].categoryName,
            data: r[1].intValue,
          }
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
      //最热Wifi热点
      new MyApis.TranResourcesApi()
        .GetWifiApTop5({"BalanceUnit":type})
        .then((r) => {
          r = r.data.Data;
          this.hotDotData.days = [];
          this.hotDotData.data = [];
          for(var i=0; i<r.length;i++){
            this.hotDotData.days[i] = r[i].Category1;
            this.hotDotData.data[i] = r[i].IntValue2;
          }
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
      //手机品牌Top10
      new MyApis.TranResourcesApi()
        .GetWifiTerminalTop10({"BalanceUnit":type})
        .then((r) => {
          r = r.data.Data;
          this.phoneTopData ={
            days: r.categoryName,
            data: r.intValue,
          }
        })
        .catch((e) => {
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    day() {
        this.getData(0);
        this.getTime(0);
    },
    week() {
        this.getData(1);
        this.getTime(1);
    },
    month() {
        this.getData(2);
        this.getTime(2);
    },
    half() {
        this.getData(3);
        this.getTime(3);
    },
    year() {
        this.getData(4);
        this.getTime(4);
    },
  },
};
</script>

<style scoped lang="scss">
.datelabel {
  border-right: 3px solid #2bc5ff;
  padding: 0 1rem;
}
.echart {
  position: relative;
  width: 100%;
  height: 100%;
}
.echart_1,
.echart_2 {
  width: 100%;
  height: 48%;
}
.echart_1{
  margin-bottom: 15px;
}
.echart_2{
  margin-top: 15px;
}
.echart_1 > div,
.echart_2 > div {
  float: left;
  width: 50%;
  height: 100%;
  color: #2bc5ff;
  font-weight: bold;
}
</style>